<template>
  <component
    :is="to ? 'router-link' : 'button'"
    class="dropdown-item"
    :class="[isActive && 'dropdown-item--active']"
    :to="to || null"
    @click="$emit('click')"
  >
    <slot />
  </component>
</template>

<script>
  export default {
    props: {
      to: {
        type: String,
        default: null
      },
      isActive: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";

  .dropdown-item {
    display: block;
    text-align: left;
    background-color: transparent;
    border: none;
    padding: 0.5rem $dropdown-padding-x;
    width: calc(100% + (#{$dropdown-padding-x} * 2));
    margin-left: -$dropdown-padding-x;
    margin-right: -$dropdown-padding-x;
    cursor: pointer;
    transition: .15s ease;
    &,
    &:hover,
    &:focus {
      color: $link-color;
      text-decoration: none;
    }
    &:hover {
      background-color: rgba($zircon, .5);
    }
    &--active {
      &,
      &:hover,
      &:focus {
        background-color: $azure;
        color: $white;
      }
    }
  }
</style>
